var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockTabler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2883_5701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.91663 1.94835C10.7964 2.45635 11.5283 3.18533 12.0399 4.06311C12.5514 4.9409 12.8248 5.93705 12.833 6.95297C12.8412 7.96888 12.5839 8.96933 12.0866 9.85526C11.5894 10.7412 10.8694 11.4819 9.99785 12.004C9.12635 12.5262 8.13359 12.8117 7.11785 12.8322C6.10211 12.8528 5.09861 12.6077 4.2067 12.1212C3.31479 11.6348 2.56538 10.9238 2.03268 10.0587C1.49998 9.19365 1.20245 8.20443 1.16954 7.18902L1.16663 7.00002L1.16954 6.81102C1.20221 5.8036 1.49536 4.82183 2.02042 3.96143C2.54547 3.10103 3.28451 2.39137 4.16548 1.90162C5.04645 1.41187 6.03929 1.15875 7.04721 1.16694C8.05513 1.17513 9.04373 1.44435 9.91663 1.94835ZM6.99996 3.50002C6.85708 3.50004 6.71918 3.55249 6.61241 3.64744C6.50564 3.74238 6.43743 3.87321 6.42071 4.0151L6.41663 4.08335V7.00002L6.42188 7.07644C6.43518 7.17764 6.4748 7.27359 6.53679 7.35469L6.58754 7.41302L8.33754 9.16302L8.39238 9.21085C8.49468 9.29022 8.62048 9.3333 8.74996 9.3333C8.87944 9.3333 9.00524 9.29022 9.10754 9.21085L9.16238 9.16244L9.21079 9.1076C9.29016 9.0053 9.33324 8.8795 9.33324 8.75002C9.33324 8.62054 9.29016 8.49474 9.21079 8.39244L9.16238 8.3376L7.58329 6.75794V4.08335L7.57921 4.0151C7.56249 3.87321 7.49428 3.74238 7.38751 3.64744C7.28074 3.55249 7.14284 3.50004 6.99996 3.50002Z",
    fill: "#774DFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2883_5701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockTabler);
export default __webpack_public_path__ + "static/media/clock-tabler.1fdde23dd211c8808432b726caec521e.svg";
export { ForwardRef as ReactComponent };